import { Dropdown } from 'react-bootstrap';

const ActionDropdownItems = ({
  firstItem,
  firstItemFunc,
  secondItem,
  secondItemFunc
}) => {
  return (
    <>
      <Dropdown.Item eventKey="1" onClick={() => firstItemFunc()}>
        {firstItem}
      </Dropdown.Item>

      <Dropdown.Divider />
      <Dropdown.Item
        eventKey="4"
        className="text-danger"
        onClick={() => secondItemFunc()}
      >
        {secondItem}
      </Dropdown.Item>
    </>
  );
};

export default ActionDropdownItems;
